import { render, staticRenderFns } from "./AddAccidenList.vue?vue&type=template&id=93f642c8&scoped=true"
import script from "./AddAccidenList.vue?vue&type=script&lang=js"
export * from "./AddAccidenList.vue?vue&type=script&lang=js"
import style0 from "./AddAccidenList.vue?vue&type=style&index=0&id=93f642c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f642c8",
  null
  
)

export default component.exports